<template>
  <div id="main" style="width:100%">
    <div id="left" style="width:50%;float:left;">
      <el-form :model="dataUsr">
        <el-row>
          <el-form-item>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">系统设置</el-breadcrumb-item>
              <el-breadcrumb-item>数据源设置</el-breadcrumb-item>
            </el-breadcrumb>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="数据源选择" :label-width="formLabelWidth">
              <el-input
                  placeholder="请选择"
                  v-model="pageName"
                  auto-complete="off"
              >
              </el-input>
              <el-tree
                  :highlight-current=true
                  :default-expand-all=false
                  :expand-on-click-node="false"
                  :data="dataUsrs"
                  :props="defaultProps"
                  :draggable="true"
                  :allow-drop="allowDrop"
                  node-key="DATSRC_ID"
                  accordion
                  @node-click="onSelectPage"
                  @node-drop="sort"
                  class="page-tree"
                  ref="pageTree"
                  :filter-node-method="filterPageNode"
              >
                <template #default="scope">
                <span class="custom-tree-node">
                    {{ scope.data.DATSRC_NAME }}
                </span>
                </template>
              </el-tree>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button-group>
              <el-button type="primary" icon="el-icon-search" @click="onSearchPageNode">搜索</el-button>
              <el-button type="primary" icon="el-icon-close" @click="onClearPageName">清空</el-button>
            </el-button-group>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div id="right" style="width:50%;float:left;">
      <el-form :model="dataUsr">
        <el-row></el-row>
        <el-row></el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="数据源操作" :label-width="formLabelWidth">
              <el-button-group>
                <el-button type="primary" icon="el-icon-plus" @click="onClickAddPage">添加数据源</el-button>
                <el-button type="primary" icon="el-icon-plus" @click="onClickAddChildPage">添加子数据源</el-button>
                <el-button type="primary" icon="el-icon-minus" @click="onClickDelPage">删除数据源</el-button>
              </el-button-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="1">
          <el-col :span="8">
            <el-form-item label="数据源类型" :label-width="formLabelWidth">
              <el-select v-model="dataUsr.DATSRC_TYPE" placeholder="数据源类型" @change="onChangePageType">
                <el-option
                    v-for="(value, key) in datasrcType"
                    :key="key"
                    :label="value.label"
                    :value="key"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item v-if="dataUsr.DATSRC_TYPE!='2'" label="数据地址" :label-width="formLabelWidth">
              <el-input placeholder="Please input" v-model="dataUsr.DATAURL"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="dataUsr.DATSRC_TYPE=='2'"  label="联合数据" :label-width="formLabelWidth">
              <el-button icon="el-icon-edit-outline"  type="text"
                         @click="unionClick()"></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="数据统计:" :label-width="formLabelWidth">
              <el-switch v-model="dataUsr.SUMMARY_MODE"></el-switch>
              <span style="margin-left: 10px">{{ dataUsr.SUMMARY_MODE == true ? "支持" : "不支持" }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item  label="表头" :label-width="formLabelWidth">
              <el-button icon="el-icon-edit-outline"  type="text"
                         @click="seriesQuery()"></el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item style="text-align: right">
              <el-button type="primary" icon="el-icon-check" @click="onClickOk()">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--表头数据—弹窗    -->
    <div v-dialogDrag>
      <el-dialog
          v-model="this.dialogTableVisible"
          title="表头数据">
        <el-input v-if="dataUsr.DATSRC_TYPE=='0'" v-model="this.seriesStr" placeholder="请输入JSON字符串"></el-input>
        <div style="margin: 15px 0px">
          <span>{{ dataUsr.SUMMARY_MODE == true ? "分组字段" : "主键" }}：</span>
          <el-select
              multiple
              collapse-tags
              collapse-tags-tooltip
              v-model="seriesPrimaryKey.KEY_COMMENTS"
              @change="OnseriesPrimaryKey"
              placeholder="暂未选择">
            <el-option
                v-for="item in this.series"
                :key="item.COLUMN_NAME"
                :label="item.COMMENTS"
                :value="item.COLUMN_NAME">
            </el-option>
          </el-select>
        </div>
        <el-table

            v-if="this.series.length>0"
            :data="this.series"
            style="width: 100%"
            stripe
            height="50vh"
            :cell-style="rowClass"
        >
          <el-table-column label="表名" header-align="center">
            <template #default="{row, column,$index}">
              <el-input size="mini" v-model="this.series[$index].TABLE_NAME" disabled></el-input>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="字段名" header-align="center">
            <template #default="{row, column,$index}">
              <!--            :disabled="this.series[$index].COLUMN_NAME!=''"-->
              <el-input size="mini" v-model="this.series[$index].COLUMN_NAME" placeholder="请输入字段名"></el-input>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="中文名称" header-align="center">
            <template #default="{row, column,$index}">
              <el-input size="mini" v-model="this.series[$index].COMMENTS" placeholder="请输入中文名称"></el-input>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="false" label="ID" header-align="center">
            <template #default="{row, column,$index}">
              <el-input size="mini" v-model="this.series[$index].id" disabled></el-input>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="数据类型" header-align="center">
            <template #default="{row, column,$index}">
              <el-input size="mini" v-model="this.series[$index].DATA_TYPE"></el-input>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="计算属性" header-align="center">
            <template #default="{row, column, $index }">
              <el-switch active-value="true"
                         inactive-value="false"
                         @click="onSeriesChecked($index,this.series[$index].checked)"
                         v-model="this.series[$index].checked">
              </el-switch>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="展示类型" header-align="center">
            <template #default="{row, column,$index}">
              <el-input size="mini" v-model="this.series[$index].type"></el-input>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" header-align="unit">
            <template #default="{row, column, $index }">
              <el-select size="mini" v-model="series[$index].unit" clearable filterable>
                <el-option
                    v-for="item in unitList"
                    :key="item.CHARACTER"
                    :label="item.LABEL"
                    :value="item.CHARACTER"></el-option>
              </el-select>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="dataUsr.SUMMARY_MODE" label="统计方式" header-align="center">
            <template #default="{row, column,$index}">
              <el-input size="mini" v-model="this.series[$index].SummaryWay"></el-input>
              <span v-show=false>{{ column }}{{ row }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" width="80px">
            <template #default="scope" header-align="center" class="tableItem">
              <el-button
                  @click.prevent="deleteRow(scope.$index, this.series)"
                  type="text"
                  size="small"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template #footer>
        <span class="dialog-footer">
          <el-button @click="this.dialogTableVisible = false">取消</el-button>
          <el-button type="success" @click="addSerirs">添加</el-button>
          <el-button type="primary" @click="seriesConfigOk">确定</el-button>
        </span>
        </template>
      </el-dialog>
    </div>
    <!--计算属性—弹窗    -->
    <div v-dialogDrag>
      <el-dialog
          v-model="this.dialogSeriesChecked"
          style="width: 200px"
          title="计算属性">
        <el-form ref="form" :model="checkedContent" label-width="100px" label-position="left">
          <el-row>
            <el-col :span="12">
              <el-form-item label="计算字段:">
                <label>{{ checkedContent.operationField.COMMENTS }}</label>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计算方式:">
                <el-select v-model="checkedContent.operationType" placeholder="暂无">
                  <el-option
                      v-for="item in this.operationType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-scrollbar height="350px">
                <el-tree
                    class="filter-tree"
                    :data="this.checkedSeries"
                    node-key="COLUMN_NAME"
                    show-checkbox
                    @check="SeriesSperationField"
                    :default-checked-keys="checkedSeriesKeys"
                    ref="operationTypeTree">
                  <template #default="{ node }">
                    <span>{{ node.label }}</span>
                  </template>
                </el-tree>
              </el-scrollbar>
            </el-col>
            <el-col :span="12" v-if="checkedContent.operationType=='custom'">
              <el-row>
                <el-form-item label="自定义算法:" style="width: 70%">
                  <el-input
                      v-model="custom.formulaStr"
                      placeholder="请输入"
                      type="textarea"
                      clearable
                      :autosize="{ minRows: 2, maxRows: 4 }"/>
                </el-form-item>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-table :data="customFieldTemp" height="300px" size="small" style="width: 120px;padding-left: 0px">
                    <el-table-column prop="COMMENTS" label="可选字段:">
                      <template #default="scope">
                    <span @click.stop="onCustomHaed(scope.row,'h')">
                      {{ scope.row.COMMENTS }}
                    </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
                <el-col :span="12">
                  <el-row>
                    <el-button v-for="item in this.customSymbols"
                               :key="item.key"
                               @click="onCustomHaed(item,item.type)"
                               text
                               class="button-icon-operation">
                      {{ item.value }}
                    </el-button>
                  </el-row>
                  <el-row>
                    <el-button v-for="item in this.customMubbers"
                               :key="item.key"
                               @click="onCustomHaed(item,item.type)"
                               text
                               class="button-icon-operation">
                      {{ item.value }}
                    </el-button>
                  </el-row>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16"></el-col>
                <el-col :span="4">
                  <el-button @click="onCustomReset">重置</el-button>
                </el-col>
                <el-col :span="4">
                  <el-button @click="onCustomTest">测试</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelSeriesChecked">取消</el-button>
          <el-button type="primary" @click="confirmSeriesChecked">确定</el-button>
        </span>
        </template>
      </el-dialog>
    </div>
    <!--联合数据—弹窗    -->
    <div v-dialogDrag>
      <dialog-ex
          v-model="drawingsDialogVisible"
          title="联合数据"
          width="60%"
          @closeMsg="closeDrawingsDialog"
          :is-footer="true">
        <template #body>
          <el-form :model="unionData">
            <el-row>
              <el-col :span="10">
                <el-form-item label="数据关联" :label-width="formLabelWidth">
                  <el-input
                      placeholder="请选择"
                      v-model="unionDataFilterText"
                      auto-complete="off"
                  >
                  </el-input>
                  <el-tree
                      :highlight-current=true
                      :default-expand-all=false
                      :data="unionDatas"
                      :props="defaultProps"
                      node-key="DATSRC_ID"
                      accordion
                      show-checkbox
                      @check="dataurlCheckChange"
                      class="module-pagetreeNew"
                      ref="unionDataTree"
                      :filter-node-method="filterNode"
                      :default-expanded-keys="unionCheckedKeys"
                      :default-checked-keys="unionCheckedKeys"
                  >
                    <template #default="scope">
                <span class="custom-tree-node">
                    {{ scope.data.DATSRC_NAME }}
                </span>
                    </template>
                  </el-tree>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="关联主表" :label-width="formLabelWidth">
                      <el-select v-model="unionData.mainTable" @change="onUnioDataMain" placeholder="请选择">
                        <el-option
                            v-for="item in unionData.data"
                            :key="item.DATSRC_ID"
                            :label="item.DATSRC_NAME"
                            :value="item.DATSRC_ID"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="关联主键" :label-width="formLabelWidth">
                      <el-select v-model="unionData.mainKey" @change="onUnioDataMainKey" multiple placeholder="请选择">
                        <el-option
                            v-for="item in unionData.data[this.unionData.mainTableNum].HEAD"
                            :key="item.COLUMN_NAME"
                            :label="item.COMMENTS"
                            :value="item.COLUMN_NAME"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="选择副表" :label-width="formLabelWidth">
                      <el-select v-model="unionData.viceTable" @change="onUnioDataVice" placeholder="请选择">
                        <el-option
                            v-for="item in unionData.data"
                            :key="item.DATSRC_ID"
                            :label="item.DATSRC_NAME"
                            :value="item.DATSRC_ID"
                            :disabled="item.disabled"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="对应字段" :label-width="formLabelWidth">
                      <el-select v-model="unionData.viceNews[this.unionData.viceTableValue].viceKey" multiple
                                 placeholder="请选择">
                        <el-option
                            v-for="item in unionData.data[this.unionData.viceNews[this.unionData.viceTableValue].viceTableNum].HEAD"
                            :key="item.COLUMN_NAME"
                            :label="item.COMMENTS"
                            :value="item.COLUMN_NAME"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <span style="padding-left: 80px">备注：勾选关联字段，请根据对应关系，按先后顺序勾选</span>
                </el-row>
                <el-row>
                  <el-form-item label="构建表头" :label-width="formLabelWidth">
                    <el-button icon="el-icon-edit-outline" type="text"
                               @click="createHead()"></el-button>
                  </el-form-item>
                </el-row>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template #footer>
        <span>
          <el-button type="primary" @click="drawingsDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="drawingsDialogVisible = false">确定</el-button>
        </span>
        </template>
      </dialog-ex>
    </div>
    <!--构建表头—弹窗    -->
    <div v-dialogDrag>
      <el-dialog
          v-model="this.dialogCreateHead"
          style="width: 200px"
          title="构建表头">
        <el-form ref="form" :model="unionData" label-width="100px" label-position="left">
          <el-row>
            <el-col :span="12">
              <el-form-item label="数据源">
                <el-select v-model="unionData.headValue" @change="onUnioDataHeader" placeholder="请选择">
                  <el-option
                      v-for="item in unionData.data"
                      :key="item.DATSRC_ID"
                      :label="item.DATSRC_NAME"
                      :value="item.DATSRC_ID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <el-form-item label="展示内容">
                <el-transfer
                    v-model="unionData.HEAD"
                    :data="unionData.data[unionData.headValueNum].headNew"
                    :props="{
                      key: 'COLUMN_NAME',
                      label: 'COMMENTS',
                  }"
                    style="text-align: left; display: inline-block"
                    :titles="['源数据列', '展示列']"
                    target-order="push"
                    filterable
                    filter-placeholder="搜索"
                    @change="choseChange"
                >
                </el-transfer>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-table :data="unionData.headData" height="300px" size="small" style="width: 200px;padding-left: 50px">
                <el-table-column prop="COMMENTS" label="最终选择字段"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-form>
        <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogCreateHead=false">取消</el-button>
          <el-button type="primary" @click="confirmHeadChecked">确定</el-button>
        </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {ElMessage, ElMessageBox} from "element-plus";
import eventInsim from "@/event";
import DialogEx from "@/components/dialogEx";
import {ref} from "vue";

export default {
  components:{
    DialogEx,
  },
  data() {
    return {
      isDataUsrTree:false,//数据关联下拉框
      dialogTableVisible: false,//数据源表头对话框
      dialogSeriesChecked: false,//计算属性对话框
      dialogCreateHead: false,//构建表头对话框
      formLabelWidth: '100px',
      remark: "",
      defaultProps: {
        children: 'children',
        label: 'DATSRC_NAME'
      },
      datasrcType: {
        "0": {
          label: "URL数据源",
          DATSRC_NAME: "URL数据源",
          HEAD: "", // "URL数据源-表头",
          DATAURL: "", //"URL数据源-数据地址",
        },
        "1": {
          label: "表数据源",
          DATSRC_NAME: "表数据源",
          DATAURL: "",
          // needTemplate: true
        },
        "2": {
          label: "联合数据源",
          DATSRC_NAME: "联合数据源",
          HEAD: "", // "URL数据源-表头",
          DATAURL: "", //"URL数据源-数据地址",
        },
      },
      pageName: "",
      sortcache: {},
      dataUsr: {
        DATSRC_NAME: "",
        DATSRC_ID: "",
        DATSRC_TYPE: "",
        DATAURL: "",
        SUMMARY_MODE:false,
        HEAD: "",
        ENABLE: "",
        remark: "",
        PARENT_DATSRC_ID: "",
        SEQUENCE: "",
        LEV: 1,
        isleaf: false,
        template: [],
        unionData:{},
        unionIsHeadModify:false,
      },//当前选中数据源信息
      dataUsrs: [],
      series: [],//表头数据
      seriesPrimaryKey:{
        KEY_COLUMN_NAME:[],//主键字段名称
        KEY_COMMENTS:[],//主键字段代码
        DATSRC_ID:"",//数据源ID
        SEQUENCE:[],//序号
      },//主键——表头数据
      seriesStr: "",//表头字符串
      seriesOld:[],//初始化 表头查询数据 未修改

      checkedContent: {
        operationField:{
          COLUMN_NAME:"",//选中字段 data属性 字符串
          COMMENTS:"暂无计算字段",//选中字段 中文名 字符串
        },
        operationType:"sum",//计算方法
        custom:{},//自定义计算方法 相关数据
      },//计算属性
      checkedSeries:[],//计算属性 下拉框 展示数据
      checkedSeriesKeys:[],//数据关联下拉框 勾选数据 id集合，用于下拉框的勾选展示
      checkedValue:"",//记录当前 计算属性 选中字段序号
      operationType: [
        {
          value: 'sum',
          label: '求和'
        }, {
          value: 'avg',
          label: '平均'
        }, {
          value: 'custom',
          label: '自定义算法'
        }],//计算属性 汇总方式

      custom:{
        params:{},
        keys:[],
        formula:"",
        formulaStr:"",//计算属性 自定义 计算展示列表 内容
      },//自定义算法参数
      customFieldTemp:[],//计算属性 自定义 可选字段，临时数据
      customSymbols: [
        {
          key: "+",
          value: "+",
          type:"s",
        }, {
          key: "-",
          value: "-",
          type:"s",
        }, {
          key: "*",
          value: "x",
          type:"s",
        }, {
          key: "/",
          value: "%",
          type:"s",
        }, {
          key: "()",
          value: "()",
          type:"s",
        }],//计算属性 自定义 计算符号集
      customMubbers:[
        {
          key: "0",
          value: "0",
          type:"n",
        },
        {
          key: "1",
          value: "1",
          type:"n",
        },
        {
          key: "2",
          value: "2",
          type:"n",
        },
        {
          key: "3",
          value: "3",
          type:"n",
        },
        {
          key: "4",
          value: "4",
          type:"n",
        },
        {
          key: "5",
          value: "5",
          type:"n",
        },
        {
          key: "6",
          value: "6",
          type:"n",
        },
        {
          key: "7",
          value: "7",
          type:"n",
        },
        {
          key: "8",
          value: "8",
          type:"n",
        },
        {
          key: "9",
          value: "9",
          type:"n",
        },
        {
          key: "C",
          value: "C",
          type:"n",
        },
      ],//计算属性 自定义 数字集
      customClickType: "s",//计算属性 自定义 点击标识，用于判断公式输入的基本逻辑 s:符号输入，h：字段输入

      unionData:{
        DATSRC_ID:"",//选中 数据源id 字符串
        data:[{
          DATSRC_NAME:"",
          DATSRC_ID:"",
          HEAD:[{
            COLUMN_NAME:"",
            COMMENTS:""
          }],//初始化表头数据
          headNew:[{
            COLUMN_NAME:"",
            COMMENTS:""
          }],//修改后表头数据：删除副表对应主键信息，修改副表同主表相同字段名称
          headChecked:[],
        }],//数据关联列表
        mainTable:"",//关联主表
        mainTableNum:0,//当前选中主表位置
        mainKey:[],//关联主键
        viceTable:"",//当前选中副表
        viceTableValue:0,//当前选中副表在副表信息列表中的位置
        viceNews:[{
          viceTable:"",//副表id
          viceTableNum:0,//副表在数据关联列表中的位置
          viceKey:"",//副表对应字段
        }],//副表信息列表

        HEAD:[],//展示表头标识信息
        headValue:"",//构建表头 选中数据源
        headValueNum:0,//构建表头 选中数据源 位置
        headData:[],//构建完成后的表头信息
      },//联合数据信息 记录
      unionIsHeadModify:false,//表头内容 修改标识
      unionDatas:[],//数据关联下拉框 展示数据
      unionCheckedKeys:[],//数据关联下拉框 勾选数据 id集合，用于下拉框的勾选展示
      unionDataFilterText:"",//数据关联 搜索数据

      unitList:[],//计量单位列表
    }
  },
  setup () {
    let drawingsDialogVisible = ref(false)
    const closeDrawingsDialog = () => {
      drawingsDialogVisible.value = false
    }
    return {
      drawingsDialogVisible,
      closeDrawingsDialog
    }
  },
  mounted: function () {
    this.getUnitList();
    this.refreshPageTree({}, 0)
  },
  methods: {
    //数据源筛选——return：true，则展示该数据源信息，否则不展示
    filterPageNode(value, data) {
      // console.log(value,data);
      if (!value) {
        return true
      }
      return data.DATSRC_NAME.indexOf(value) !== -1
    },
    //获取计量单位数据集
    getUnitList(){
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getUnitList").then(res=>{
        this.unitList=res.data;
      }).catch(err=>{
        console.log(err);
      })
    },
    //查询表头数据
    async seriesQuery() {
      let that = this;
      that.series="";
      console.log(that.dataUsr);
      this.seriesPrimaryKey.DATSRC_ID=that.dataUsr.DATSRC_ID;

      //联合数据源——页面修改过表头信息，则进入此判断，直接赋页面表头信息，不需要读取后台表头信息
      if (that.dataUsr.DATSRC_TYPE == '2' && this.unionData.DATSRC_ID!="" && this.unionIsHeadModify==false) {
        if (that.unionData.headData.length==0) {
          alert("联合数据未完善，请先选择联合数据");
          return;
        }
        console.log(1)
        that.series = JSON.parse(JSON.stringify(that.unionData.headData));
        that.seriesOld = JSON.parse(JSON.stringify(that.unionData.headData));
      }
      else {
        await axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/seriesQuery",
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            id: that.dataUsr.DATSRC_ID
          }
        }).then((res) => {
          if (res.status === 200) {
            console.log(res);
            that.series = res.data.content.headerArray;
            that.seriesOld = JSON.parse(JSON.stringify(res.data.content.headerArray));
            //判断是否存在主键信息
            if ('dataPky' in res.data.content){
              // this.seriesPrimaryKey.KEY_COMMENTS=res.data.content.dataPky.KEY_COLUMN_CODE.split(", ");
              let KEY_COLUMN_CODE=res.data.content.dataPky.KEY_COLUMN_CODE;
              this.seriesPrimaryKey.KEY_COMMENTS=KEY_COLUMN_CODE.substring(1,KEY_COLUMN_CODE.length-1).split(", ");
            }
          }
        }).catch((err) => {
          alert('Error');
          console.log(err)
        })
      }

      console.log("主键：",this.seriesPrimaryKey);
      that.dialogTableVisible = true;
    },
    //添加表头数据
    addSerirs() {
      if(this.dataUsrs.SUMMARY_MODE)
      {
        this.series.push({
          TABLE_NAME: this.dataUsr.DATSRC_TYPE!="2"? this.dataUsr.DATAURL : "",//数据银行表名
          COLUMN_NAME: "",//银行对应字段
          COMMENTS: "",//中文名称
          DATA_TYPE:"VARCHAR2",
          type:"text",
          SummaryWay:"SUM",
          // edit: false,
          checked: "false",//是否是计算字段
          // checkedContent:"",//计算属性
          id: this.series.length>0?this.series[this.series.length-1].id+1:this.series.length
        });
      }
      else{
        this.series.push({
          TABLE_NAME: this.dataUsr.DATSRC_TYPE!="2"? this.dataUsr.DATAURL : "",//数据银行表名
          COLUMN_NAME: "",//银行对应字段
          COMMENTS: "",//中文名称
          DATA_TYPE:"VARCHAR2",
          type:"text",
          // edit: false,
          checked: "false",//是否是计算字段
          // checkedContent:"",//计算属性
          id: this.series.length
        });
      }

      // console.log(this.series);
    },
    //删除表头数据
    deleteRow(index, rows) {
      ElMessageBox.confirm(
          '你真的要删除这一行数据吗',
          'warning', {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning"
          }
      ).then(() => {
        rows.splice(index, 1);
        ElMessage({type: "success", message: "删除成功"})
      }).catch(() => {
        ElMessage({type: "info", message: "删除已取消"})
      })

    },
    //提交表头数据
    seriesConfigOk() {
      let that = this;
      //统计方式，分组字段不允许为空
      if(that.dataUsrs.SUMMARY_MODE){
        if(that.seriesPrimaryKey.KEY_COLUMN_NAME.length<=0){
          ElMessage({
            type: 'warning',
            message: '统计模式必须设置分组字段，请设置后重试！',
          })
          return ;
        }
      }
      //如果是URL数据则提交保存
      //if (that.dataUsr.DATSRC_TYPE=='0')
      {
        let headData=[];
        console.log(that.seriesOld);
        let len = that.series.length;
        //判断提交表头数据与查询表头数据是否有增删，有添加修改标识
        if (len!=that.seriesOld.length){
          that.unionIsHeadModify=true;
        }
        // 给表头添加label，data属性,以及其他需要属性
        for (let i = 0; i < len; i++) {
          // console.log("3333",that.series[i].type)
          headData.push({
            id:'id' in that.series[i] ? that.series[i].id : i,
            COMMENTS: that.series[i].COMMENTS,
            COLUMN_NAME: that.series[i].COLUMN_NAME,
            TABLE_NAME: that.series[i].TABLE_NAME,
            data:'data' in that.series[i] ? that.series[i].data : that.series[i].COLUMN_NAME,
            label: 'label' in that.series[i] ? that.series[i].label :  that.series[i].COMMENTS,
            DATA_TYPE: that.series[i].DATA_TYPE,
            SummaryWay: that.series[i].SummaryWay,
            type: that.series[i].type,
            checked: that.series[i].checked,
            checkedContent: that.series[i].checkedContent,
            DATAURL: 'DATAURL' in that.series[i] ? that.series[i].DATAURL : null,
            unit: 'unit' in that.series[i] ? that.series[i].unit : null,
          })
        }
        let id = that.dataUsr.DATSRC_ID;
        let seriesStr = that.seriesStr;//字符串数据
        let seriesArray = [];//表格数据
        seriesArray.push({
          header: headData
          // dataSource: "V_CD_WELL_BASICS"
        });
        console.log("series:",that.series);
        console.log("headData:",headData);
        console.log("seriesArray:",seriesArray);
        if (len >= 0) {
          axios({
            url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/series",
            method: 'POST',
            headers: {
              "Content-Type": "application/json"
            },
            data: {
              series: seriesArray,
              id: id,
              seriesStr: seriesStr,
              type:that.dataUsr.DATSRC_TYPE,
              SUMMARY_MODE:that.dataUsr.SUMMARY_MODE,
              seriesPrimaryKey:this.seriesPrimaryKey
            }
          }).then((res) => {
            if (res.status === 200) {
              console.log(res);
              ElMessage({
                type: 'success',
                message: '表头数据添加成功',
              })
            }
          }).catch((err) => {
            alert('Error');
            console.log(err)
          })
        }
        that.dataUsr.HEAD = JSON.stringify(seriesArray);
        // that.dataUsr.DATSRC_TYPE = "0";
        console.log(seriesArray);
      }
      that.dialogTableVisible = false;
    },
    //选中表头主键数据
    OnseriesPrimaryKey(node){
      this.seriesPrimaryKey.KEY_COMMENTS=node;
      this.seriesPrimaryKey.KEY_COLUMN_NAME=[];
      this.seriesPrimaryKey.SEQUENCE=[];
      console.log(node)
      for (let nIdex=0;nIdex<node.length;nIdex++){
        for (let i=0;i<this.series.length;i++){
          if (this.series[i].COLUMN_NAME==node[nIdex]){
            this.seriesPrimaryKey.KEY_COLUMN_NAME.push(this.series[i].COMMENTS);
            this.seriesPrimaryKey.SEQUENCE.push(this.series[i].id);
            break;
          }
        }
      }
      console.log(this.seriesPrimaryKey)
    },


    //查询数据源信息
    async fetchAllPage() {
      let that = this;
      await axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/datasrc",
        method: 'GET',
      }).then((res) => {
        if (res.status === 200) {
          that.dataUsrs = res.data;
        }
        console.log('数据源信息：', res);
      }).catch((err) => {
        alert('Error');
        console.log(err)
      })
    },
    async refreshPageTree(parentPage, selIndex) {
      // console.log("就上班上班",parentPage,selIndex);
      let that = this
      await that.fetchAllPage();
      if (Object.keys(parentPage).length === 0) {
        if (selIndex < 0) {
          that.dataUsr = that.dataUsrs[that.dataUsrs.length + selIndex];
        } else {
          that.dataUsr = that.dataUsrs[selIndex];
          console.log("页面加载数据:", that.dataUsr);
        }
      } else {
        parentPage = that.findPage(that.dataUsrs, parentPage)
        if (selIndex < 0) {
          that.dataUsr = parentPage.children[parentPage.children.length + selIndex]
        } else {
          that.dataUsr = parentPage.children[selIndex]
        }
      }
      // that.dataUsr.template = []
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.data.level === dropNode.data.level) {
        //aboveId:父节点id
        if (draggingNode.parent.id === dropNode.parent.id) {
          return type === "prev" || type === "next";
        }
      } else {
        // 不同级进行处理 直接退出
        return false;
      }
    },
    sort(draggingNode, dropNode, type) {
      let that = this;
      let data = type != "inner" ? dropNode.parent.data : dropNode.data;
      let nodeData = dropNode.level == 1 && type != "inner" ? data : data.children;
      nodeData = Array.from(nodeData);
      nodeData.forEach(element => {
        element.pid = data.DATSRC_ID;
      });
      nodeData.forEach((element, i) => {
        // 向上拖动
        if (draggingNode.data.SEQUENCE > dropNode.data.SEQUENCE) {
          if (element.SEQUENCE >= dropNode.data.SEQUENCE && element.SEQUENCE <= draggingNode.data.SEQUENCE) {
            let Seq = element.SEQUENCE;
            Seq = Seq.toString();
            let M = element.LEV;
            let temSeq = "";
            if (i + 1 < 10) {
              temSeq = Seq.substring(0, 2 * M - 1) + "0" + "" + (i + 1) + Seq.substring(2 * M + 1);
              element.SEQUENCE = temSeq;
            } else {
              temSeq = Seq.substring(0, 2 * M - 1) + "" + (i + 1) + Seq.substring(2 * M + 1);
              element.SEQUENCE = temSeq;
            }
            that.sortcache[element.DATSRC_ID] = temSeq;
            // 处理子节点
            if (element.isLeaf == false) {
              let len = element.children.length;
              let leafSeq = ""
              for (let j = 0; j < len; j++) {
                leafSeq = element.children[j].SEQUENCE
                leafSeq = leafSeq.toString();
                let temleafSeq = "";
                if (i + 1 < 10) {
                  temleafSeq = leafSeq.substring(0, 2 * M - 1) + "0" + "" + (i + 1) + leafSeq.substring(2 * M + 1);
                  element.children[j].SEQUENCE = temleafSeq;
                } else {
                  temleafSeq = leafSeq.substring(0, 2 * M - 1) + "" + (i + 1) + leafSeq.substring(2 * M + 1);
                  element.children[j].SEQUENCE = temleafSeq;
                }
                that.sortcache[element.children[j].DATSRC_ID] = temleafSeq;
              }

            }
          }
        }
        // 向下拖动
        else {
          if (element.SEQUENCE >= draggingNode.data.SEQUENCE && element.SEQUENCE <= dropNode.data.SEQUENCE) {
            let Seq = element.SEQUENCE;
            Seq = Seq.toString();
            let M = element.LEV;
            let temSeq = "";
            if (i + 1 < 10) {
              temSeq = Seq.substring(0, 2 * M - 1) + "0" + "" + (i + 1) + Seq.substring(2 * M + 1);
              element.SEQUENCE = temSeq;
            } else {
              temSeq = Seq.substring(0, 2 * M - 1) + "" + (i + 1) + Seq.substring(2 * M + 1);
              element.SEQUENCE = temSeq;
            }
            that.sortcache[element.DATSRC_ID] = temSeq;
            // 处理子节点
            if (element.isLeaf == false) {
              let len = element.children.length;
              let leafSeq = ""
              for (let j = 0; j < len; j++) {
                leafSeq = element.children[j].SEQUENCE
                leafSeq = leafSeq.toString();
                let temleafSeq = "";
                if (i + 1 < 10) {
                  temleafSeq = leafSeq.substring(0, 2 * M - 1) + "0" + "" + (i + 1) + leafSeq.substring(2 * M + 1);
                  element.children[j].SEQUENCE = temleafSeq;
                } else {
                  temleafSeq = leafSeq.substring(0, 2 * M - 1) + "" + (i + 1) + leafSeq.substring(2 * M + 1);
                  element.children[j].SEQUENCE = temleafSeq;
                }
                that.sortcache[element.children[j].DATSRC_ID] = temleafSeq;
              }
            }
          }
        }
      });
      console.log(that.sortcache)
    },
    //点击搜索按钮
    onSearchPageNode() {
      console.log(this.pageName)
      this.$refs.pageTree.filter(this.pageName)
    },
    //点击清空按钮
    onClearPageName() {
      this.pageName = ""
      this.$refs.pageTree.filter(this.pageName)
    },
    //tree组件 搜索筛选
    //过滤节点
    filterNode(value, data) {
      if (!value) return true;
      return data.DATSRC_NAME.indexOf(value) !== -1;
    },
    findPage(node, data) {
      let item = null
      for (let i = 0; i < node.length; i++) {
        console.log(node[i].DATSRC_ID + " " + data.DATSRC_ID)
        if (node[i].DATSRC_ID == data.DATSRC_ID) {
          item = node[i]
          break
        }
        if (!node[i].isLeaf) {
          const it = this.findPage(node[i].children, data)
          if (it) {
            return it
          }
        }
      }
      return item
    },
    addPage(dataUsr) {
      let that = this;
      let pid = (Object.keys(dataUsr).length === 0) ? "root" : dataUsr.DATSRC_ID;
      let lev = (Object.keys(dataUsr).length === 0) ? "0" : dataUsr.LEV;
      let summaryMode = (Object.keys(dataUsr).length === 0) ? false : dataUsr.SUMMARY_MODE;
      ElMessageBox.prompt(
          '数据源名称',
          '输入',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
      ).then(({value}) => {
        let name = (value != null) ? `${value}` : ""
        if (name.trim() == "") {
          ElMessage({
            type: 'warning',
            message: '名称不能为空',
          })
          return
        }
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/datasrc",
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            dataName: name,
            pid: pid,
            lev: lev,
            SUMMARY_MODE: summaryMode

          }
        }).then((res) => {
          if (res.status === 200) {
            console.log(res);
            that.refreshPageTree(dataUsr, -1)
            ElMessage({
              type: 'success',
              message: '页面添加成功',
            })
          }
        }).catch((err) => {
          alert('Error');
          console.log(err)
        })
      })
    },
    //选择下拉框节点触发
    onSelectPage(node) {
      console.log(node);
      let that = this;
      that.dataUsr = {}
      that.dataUsr.DATSRC_ID = node.DATSRC_ID;
      that.dataUsr.DATSRC_NAME = node.DATSRC_NAME;
      that.dataUsr.DATSRC_TYPE = node.DATSRC_TYPE;
      that.dataUsr.ENABLE = node.ENABLE;
      that.dataUsr.HEAD = node.HEAD == null ? "" : node.HEAD;
      that.dataUsr.DATAURL = node.DATAURL == null ? "" : node.DATAURL;
      that.dataUsr.PARENT_DATSRC_ID = node.PARENT_DATSRC_ID;
      that.dataUsr.SEQUENCE = node.SEQUENCE;
      that.dataUsr.LEV = node.LEV;
      that.dataUsr.isLeaf = node.ISLEAF;
      that.dataUsr.SUMMARY_MODE = node.SUMMARY_MODE;
      that.dataUsr.template = [];
      that.pageName = node.DATSRC_NAME;
      // console.log(that.dataUsr);

      //切换数据源，初始化联合数据源配置信息
      that.unionData={
        DATSRC_ID:"",//选中 数据源id 字符串
        data:[{
          DATSRC_NAME:"",
          DATSRC_ID:"",
          HEAD:[{
            COLUMN_NAME:"",
            COMMENTS:""
          }],
          headNew:[{
            COLUMN_NAME:"",
            COMMENTS:""
          }],
          headChecked:[],
        }],//数据关联列表
        mainTable:"",//关联主表
        mainTableNum:0,//当前选中主表位置
        mainKey:[],//关联主键
        viceTable:"",//当前选中副表
        viceTableValue:0,//当前选中副表在副表信息列表中的位置
        viceNews:[{
          viceTable:"",//副表id
          viceTableNum:0,//副表在数据关联列表中的位置
          viceKey:"",//副表对应字段
        }],//副表信息列表

        HEAD:[],//展示表头标识信息
        headValue:"",//构建表头 选中数据源
        headValueNum:0,//构建表头 选中数据源 位置
        headData:[],//构建完成后的表头信息
      };//联合数据信息 记录
      that.unionIsHeadModify=false;
    },
    //添加数据源
    onClickAddPage() {
      this.addPage({})
    },
    //添加子数据源
    onClickAddChildPage() {
      this.addPage(this.dataUsr)
    },
    //删除数据源
    onClickDelPage() {
      let that = this
      let id = that.dataUsr.DATSRC_ID
      // let seq = that.dataUsr.seq
      ElMessageBox.confirm(
          '确定删除？',
          '警告',
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning',
          }
      ).then(() => {
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/datasrc",
          method: 'DELETE',
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            id: id,
            seq: that.dataUsr.SEQUENCE
          }
        }).then((res) => {
          if (res.status === 200) {
            console.log(res);
            that.refreshPageTree({}, 0)
            if (that.dataUsrs.length > 0) {
              that.dataUsr = that.dataUsrs[0]
              that.dataUsr.template = []
            }
            ElMessage({
              type: 'success',
              message: '页面删除成功',
            })
          }
        }).catch((err) => {
          alert('Error');
          console.log(err)
        })
      })
    },
    onChangePageType(type) {
      let that = this;
      // console.log(type);
      that.dataUsr.DATSRC_TYPE = type;
      that.dataUsr.HEAD = type==0?that.datasrcType[type].HEAD:"";
      that.dataUsr.DATAURL =that.datasrcType[type].DATAURL;
      that.dataUsr.template = [];
      console.log(that.dataUsr);

    },
    //曲线内容剧中
    rowClass(){
      return 'text-align: center;'
    },
    //提交按钮
    onClickOk() {
      let that = this;
      that.dataUsr.DATSRC_NAME = that.pageName;
      that.dataUsr.unionData=that.unionData;
      that.dataUsr.unionIsHeadModify=that.unionIsHeadModify;
      console.log(that.dataUsr);
      if (that.dataUsr.DATSRC_NAME.trim() == "") {
        ElMessage({
          type: 'warning',
          message: '请选择数据源',
        })
        return
      }
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/datasrc",
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        data: that.dataUsr
      }).then((res) => {
        if (res.status === 200) {
          // 导航栏拖动排序后储存
          axios({
            url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/sortcache3",
            method: 'POST',
            headers: {
              "Content-Type": "application/json"
            },
            data: that.sortcache
          }).then((res) => {
            if (res.status === 200) {
              console.log(res);
              // that.fetchAllPage();
              eventInsim.emit("DataChange", that.dataUsr);
              // that.$router.go(0);//刷新页面
            }
            console.log(this.dataUsr);
          }).catch((err) => {
            console.log(err)
          })
          console.log(res);
          ElMessage({
            type: 'success',
            message: '修改成功',
          })
        }
      }).catch((err) => {
        console.log(that.dataUsr)
        alert('error');
        console.log(err)
      })

    },

    //点击计算属性
    onSeriesChecked(index,checked){
      console.log(index,checked);
      // console.log(this.series);
      if (checked=="false"){
        return;
      }

      this.checkedSeries=[];
      this.checkedSeriesKeys=[];
      this.custom={};
      this.customFieldTemp=[];

      for (let i=0;i<this.series.length;i++){
        let item=this.series[i];
        if (item.checked=="false" && i!=index){
          this.checkedSeries.push(item);
        }
      }
      console.log("可选字段列表：",this.checkedSeries);
      this.checkedContent.operationField.keys =this.series[index].checkedContent===undefined ? "" : this.series[index].checkedContent.operationField.keys;
      this.checkedContent.operationField.COLUMN_NAME =this.series[index].checkedContent===undefined ? " " : this.series[index].checkedContent.operationField.COLUMN_NAME;
      this.checkedContent.operationField.COMMENTS =this.series[index].checkedContent===undefined ? "暂无计算字段" : this.series[index].checkedContent.operationField.COMMENTS;
      this.checkedContent.operationType = this.series[index].checkedContent===undefined ? "sum" : this.series[index].checkedContent.operationType;
      this.checkedContent.custom= {};
      if (this.checkedContent.operationType=="custom"){
        this.checkedContent.custom = this.series[index].checkedContent.custom;
        this.custom = this.series[index].checkedContent.custom;
      }
      console.log("计算属性:",this.checkedContent);

      this.checkedSeriesKeys=this.checkedContent.operationField.keys!==undefined && this.checkedContent.operationField.keys!="" ?this.checkedContent.operationField.keys.split(",") : [];
      console.log("keys:",this.checkedSeriesKeys);
      for (let i=0;i<this.checkedSeriesKeys.length;i++){
        for (let j=0;j<this.checkedSeries.length;j++){
          if (this.checkedSeriesKeys[i]==this.checkedSeries[j].COLUMN_NAME){
            this.customFieldTemp.push(this.checkedSeries[j]);
          }
        }
      }
      console.log("customFieldTemp:",this.customFieldTemp);

      this.checkedValue=index;
      this.dialogSeriesChecked=true;
    },
    //选择 计算字段 时 触发
    SeriesSperationField(currentNode, checkedObjs){
      console.log("点击数据信息：",currentNode)
      console.log("勾选数据信息：",checkedObjs)
      console.log("计算属性：",this.checkedContent)
      for (let i=0;i<checkedObjs.checkedNodes.length;i++){
        if (i==0){
          this.checkedContent.operationField.COMMENTS = checkedObjs.checkedNodes[i].COMMENTS;
          this.checkedContent.operationField.COLUMN_NAME = checkedObjs.checkedNodes[i].data;
          this.checkedContent.operationField.keys = checkedObjs.checkedNodes[i].COLUMN_NAME;
          if ('DATAURL' in checkedObjs.checkedNodes[i])
            this.checkedContent.operationField.DATAURL = checkedObjs.checkedNodes[i].DATAURL;
        } else {
          this.checkedContent.operationField.COMMENTS += "," + checkedObjs.checkedNodes[i].COMMENTS;
          this.checkedContent.operationField.COLUMN_NAME += "," + checkedObjs.checkedNodes[i].data;
          this.checkedContent.operationField.keys += "," + checkedObjs.checkedNodes[i].COLUMN_NAME;
          if ('DATAURL' in checkedObjs.checkedNodes[i])
            this.checkedContent.operationField.DATAURL += "," + checkedObjs.checkedNodes[i].DATAURL;
        }
      }

      //自定义算法初始化赋值
      this.custom.params = {};
      this.custom.keys = [];
      this.custom.formula = "";
      this.custom.formulaStr = "";
      this.checkedContent.custom= {};
      this.customClickType="s";

      this.customFieldTemp = [];
      this.customFieldTemp = checkedObjs.checkedNodes;
      console.log("自定义 可选字段:", this.customFieldTemp);
    },
    //点击 确定——计算属性弹出框
    confirmSeriesChecked(){
      this.checkedContent.custom={};
      if (this.checkedContent.operationType=="custom"){
        this.checkedContent.custom=this.custom;
      }
      this.custom={};
      this.series[this.checkedValue]['checkedContent']=this.checkedContent;
      // this.checkedContent.operationField.COMMENTS="暂无计算字段";
      // this.checkedContent.operationField.COLUMN_NAME="";
      this.dialogSeriesChecked=false;
      console.log("修改字段：",this.series[this.checkedValue]);
    },
    //点击 取消——计算属性弹出框
    cancelSeriesChecked(){
      this.series[this.checkedValue].checked="false";
      this.dialogSeriesChecked=false;
    },

    //点击 联合数据 打开弹窗
    unionClick(){
      this.unionCheckedKeys=[];
      //判断当前是否存在配置信息，若存在则不读取保存配置信息
      if (!(this.unionData.DATSRC_ID != "")) {
        axios({
          url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/getunionData",
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          data: {
            DATSRC_ID: this.dataUsr.DATSRC_ID
          }
        }).then((res) => {
          console.log(res);
          this.unionDatas = res.data.content.datas;
          //初始化联合配置信息数据
          let unionData = {
            DATSRC_ID: "",//选中 数据源id 字符串
            data: [{
              DATSRC_NAME: "",
              DATSRC_ID: "",
              HEAD: [{
                COLUMN_NAME: "",
                COMMENTS: ""
              }],
              headNew: [{
                COLUMN_NAME: "",
                COMMENTS: ""
              }],
              headChecked: [],
            }],//数据关联列表
            mainTable: "",//关联主表
            mainTableNum: 0,//当前选中主表位置
            mainKey: [],//关联主键
            viceTable: "",//当前选中副表
            viceTableValue: 0,//当前选中副表在副表信息列表中的位置
            viceNews: [{
              viceTable: "",//副表id
              viceTableNum: 0,//副表在数据关联列表中的位置
              viceKey: "",//副表对应字段
            }],//副表信息列表

            HEAD: [],//展示表头标识信息
            headValue: "",//构建表头 选中数据源
            headValueNum: 0,//构建表头 选中数据源 位置
            headData: [],//构建完成后的表头信息
          }
          this.unionData = unionData;
          //存在配置信息，则覆盖
          if (res.data.content.object != null) {
            this.unionData = res.data.content.object;
          }
          this.unionCheckedKeys = this.unionData.DATSRC_ID.split(",");
        }).catch((err) => {
          alert('Error');
          console.log(err)
          return;
        })
      }
      this.drawingsDialogVisible = true;
    },
    //点击数据关联 下拉按钮
    popDataUsrTree() {
      let _this = this;
      _this.isDataUsrTree = !_this.isDataUsrTree;
      console.log(this.isDataUsrTree);
    },
    //数据关联 下拉框展开时点击空白处关闭下拉框
    unPopDataSurTree() {
      this.isDataUsrTree = false;
    },

    //获取 数据关联 勾选数据
    dataurlCheckChange(currentNode, checkedObjs) {
      console.log(currentNode,checkedObjs);
      this.unionData.data = [];//清空数据
      //当勾选数据为空时，构造空的数据记录
      if (checkedObjs.checkedKeys.length==0){
        this.unionData.data = [{
          DATSRC_NAME: "",
          DATSRC_ID: "",
          HEAD: [{
            COLUMN_NAME: "",
            COMMENTS: "",
          }]
        }];
        return ;
      }
      //循环勾选数据
      for (let i = 0; i < checkedObjs.checkedNodes.length; i++) {
        //添加表名，数据源id，表头,可勾选标识
        this.unionData.data.push({
          DATSRC_NAME: checkedObjs.checkedNodes[i].DATSRC_NAME,
          DATSRC_ID: checkedObjs.checkedNodes[i].DATSRC_ID,
          DATAURL: checkedObjs.checkedNodes[i].DATAURL,
          HEAD: checkedObjs.checkedNodes[i].HEAD.length!=0 ?checkedObjs.checkedNodes[i].HEAD[0].header:[],
          disabled: checkedObjs.checkedNodes[i].DATSRC_ID==this.unionData.mainTable? true : false,
        });
        //todo 矫正data不是存储字段名的数据源，否则报表获取数据时会出错
        if(this.unionData.data[i].HEAD!=[]){
          for (let h=0;h<this.unionData.data[i].HEAD.length;h++){
            this.unionData.data[i].HEAD[h].data=this.unionData.data[i].HEAD[h].COLUMN_NAME;
            this.unionData.data[i].HEAD[h].label=this.unionData.data[i].HEAD[h].COMMENTS;
          }
        }
      }
      this.unionData.DATSRC_ID=checkedObjs.checkedKeys.toString();
      this.unionCheckedKeys=checkedObjs.checkedKeys;
      //判断当前选中数据源中是否包含 关联主表的数据源，不包含则 清空 关联主表信息和 主键信息
      if(this.unionData.DATSRC_ID.indexOf(this.unionData.mainTable)==-1){
        this.unionData.mainTable="";
        this.unionData.mainTableNum=0;
        this.unionData.mainKey=[];
      }
      //判断当前选中数据源中是否包含 关联副表的数据源，不包含则 清空
      if(this.unionData.DATSRC_ID.indexOf(this.unionData.viceTable)==-1){
        this.unionData.viceTable="";
        this.unionData.viceTableValue=0;
        this.unionData.viceNews=[{
          viceTable:"",
          viceTableNum:0,
          viceKey:"",
        }];
      }
      //todo 重新构建副表列表信息。   当选择主表后再重新勾选数据源，不会刷新副表列表信息，在不重新选择主表的情况下，选择副表会出现表头数据不匹配的情况。
      if (this.unionData.mainTable!=""){
        this.unionData.viceNews=[];
        //循环勾选数据源信息，构建副表信息记录
        for (let i=0;i<this.unionData.data.length;i++){
          if (!this.unionData.data[i].disabled){
            this.unionData.viceNews.push({
              viceTable: this.unionData.data[i].DATSRC_ID,
              viceTableNum: i,
              viceKey: []
            });
          }
        }
      }
      console.log(this.unionData);
    },
    //选中 关联主表 下拉框
    onUnioDataMain(value) {
      console.log(value);
      let unionData = this.unionData;
      this.unionData.mainKey = [];//清空勾选关联主键信息
      //判断选中主表 是否是 当前选中副表，如果是，则清空当前选中副表信息
      if (value == unionData.viceTable) {
        this.unionData.viceTable = "";
      }
      //循环勾选数据源信息，添加标识，记录位置
      for (let i = 0; i < unionData.data.length; i++) {
        this.unionData.data[i].disabled = false;//可以选中标识
        if (value == unionData.data[i].DATSRC_ID) {
          this.unionData.mainTableNum = i;//记录当前选择主表位置信息
          this.unionData.data[i].disabled = true;//当前选中主表 添加 不可选中标识
        }
      }
      this.unionData.viceNews=[];//清空副表信息
      let isTemp=true;//添加副表信息 标识
      //循环勾选数据源信息，构建副表信息记录
      for (let i=0;i<unionData.data.length;i++){
        if (!unionData.data[i].disabled){
          this.unionData.viceNews.push({
            viceTable: unionData.data[i].DATSRC_ID,
            viceTableNum: i,
            viceKey: []
          });
          //自动选中一张副表 展示
          if (isTemp){
            this.unionData.viceTable=unionData.data[i].DATSRC_ID;
            this.unionData.viceTableValue=this.unionData.viceNews.length-1;
            isTemp=false;
          }
        }
      }
      console.log(this.unionData);
    },
    //选中 关联主键 下拉框
    onUnioDataMainKey(){
      let unionData=this.unionData;
      //循环副表信息，判断 副表的 表头信息 中是否存在 关联主键 的 对应字段 ，存在则自动添加到 对应字段 中
      for (let i=0;i<unionData.viceNews.length;i++){
        let head = unionData.data[unionData.viceNews[i].viceTableNum].HEAD;
        let viceKey=[];
        //循环关联主键 字段
        for (let m=0;m<unionData.mainKey.length;m++){
          for (let j=0;j<head.length;j++){
            if (head[j].COLUMN_NAME==unionData.mainKey[m]){
              viceKey.push(unionData.mainKey[m])
              break;
            }
          }
        }
        this.unionData.viceNews[i].viceKey=viceKey;
      }
      console.log(this.unionData)
    },
    //选中 选择副表 下拉框
    onUnioDataVice(value) {
      let unionData=this.unionData;
      this.unionData.viceTable = value;//当前选中副表id
      //记录当前选中副表位置信息
      for (let i=0;i<unionData.viceNews.length;i++){
        if (value==unionData.viceNews[i].viceTable){
          this.unionData.viceTableValue=i;
        }
      }
      console.log(this.unionData)
    },
    //点击 构建表头 按钮
    createHead(){
      console.log(this.unionData);
      let unionData=this.unionData;
      let tips="请选择："
      if (unionData.mainTable=="") tips+="关联主表，"
      if (unionData.mainKey.length==0) tips+="关联主键，"
      if (unionData.viceTable=="") tips+="副表，"
      if (tips.length>4){
        alert(tips.substring(0,tips.length-1));
        return ;
      }
      for (let i=0;i<unionData.viceNews.length;i++){
        if (unionData.viceNews[i].viceKey.length!=unionData.mainKey.length){
          tips="关联主键与副表对应字段数不一致，请完善数据";
        }
      }
      if (tips.length>4){
        alert(tips);
        return ;
      }

      //构建表头数组，关联字段只保留一条记录，
      //添加所有表的表头信息，用于判断关键字段和重复字段   复制关联主表 对应 表头信息，该方法不会更改原数组数据
      let headAll=(unionData.data[unionData.mainTableNum].HEAD).slice(0);
      this.unionData.data[unionData.mainTableNum].headNew = (headAll).slice(0);//添加主表headNew表头数组
      //循环副表数据
      for (let i=0;i<unionData.viceNews.length;i++){
        //获取副表对应表头信息
        // let headTemp=(unionData.data[unionData.viceNews[i].viceTableNum].HEAD).slice(0);//修改变量，原数组会改变
        let headTemp=JSON.parse(JSON.stringify(unionData.data[unionData.viceNews[i].viceTableNum].HEAD))

        //循环副表表头数据； 判断 表头数据 是否包含于 副表的关联字段中，包含则不添加
        for (let j=headTemp.length-1;j>-1;j--){
          if (unionData.viceNews[i].viceKey.toString().indexOf(headTemp[j].COLUMN_NAME)==-1){
            //循环已添加表头信息，判断是否存在标识相同的数据，存在则修改对应副表字段标识
            for (let m=0;m<headAll.length;m++){
              if (headTemp[j].COLUMN_NAME==headAll[m].COLUMN_NAME){
                headTemp[j].COLUMN_NAME+=i;
                break
              }
            }
            headAll.push(headTemp[j]);
          }else {
            headTemp.splice(j,1);//副表表头 删除 对应字段 数据
          }
          this.unionData.data[unionData.viceNews[i].viceTableNum].headNew=headTemp;//添加副表headNew表头数组
        }
      }

      //给勾选主键添加不可选中标识  展示表头字段(展示列)必须包括关联主键
      for (let i=0;i<unionData.mainKey.length;i++){
        for (let j=0;j<unionData.data[unionData.mainTableNum].headNew.length;j++){
          if (unionData.mainKey[i]==unionData.data[unionData.mainTableNum].headNew[j].COLUMN_NAME){
            unionData.data[unionData.mainTableNum].headNew[j].disabled=true;
          }
        }
      }
      //构建表头 给数据源选择下拉框赋值，表头初始化添加主键字段
      this.unionData.headValue=this.unionData.mainTable;
      this.unionData.headValueNum=this.unionData.mainTableNum;
      //将主键字段添加到HEAD中，若副表字段名称不同，则添加对应字段名称
      this.unionData.HEAD=(this.unionData.mainKey).slice(0);
      for (let i=0;i<unionData.viceNews.length;i++){
        for (let j=0;j<unionData.viceNews[i].viceKey.length;j++){
          if (this.unionData.HEAD.indexOf(unionData.viceNews[i].viceKey[j])==-1){
            this.unionData.HEAD.push(unionData.viceNews[i].viceKey[j]);
          }
        }
      }

      //判断headData是否为空；不为空，则添加进HEAD中
      let headData=this.unionData.headData;
      if (headData!=[]){
        for (let hIdx=0;hIdx<headData.length;hIdx++){
          if (this.unionData.HEAD.indexOf(headData[hIdx].COLUMN_NAME)==-1){
            this.unionData.HEAD.push(headData[hIdx].COLUMN_NAME);
          }
        }
      }
      this.dialogCreateHead=true;
    },
    //选中 构建表头 数据源 下拉框
    onUnioDataHeader(value) {
      let unionData=this.unionData;
      this.unionData.headValue = value;//当前选中数据源id
      //记录当前选中数据源位置信息
      for (let i=0;i<unionData.data.length;i++){
        if (value==unionData.data[i].DATSRC_ID){
          this.unionData.headValueNum=i;
        }
      }
      console.log(this.unionData)
    },
    //构建表头 切换所展示的列触发
    choseChange(value, where, arr) {
      console.log(value, where, arr);
      console.log(this.unionData);
      let headrData=[];//最终展示字段 列表
      let headrDataIdx=0;//记录id
      //展示字段合成 数组
      for (let i = 0; i < this.unionData.HEAD.length; i++) {
        for (let j = 0; j < this.unionData.data.length; j++) {
          for (let k = 0; k < this.unionData.data[j].headNew.length; k++) {
            if (this.unionData.data[j].headNew[k].COLUMN_NAME == this.unionData.HEAD[i]) {
              let headrTemp=JSON.parse(JSON.stringify(this.unionData.data[j].headNew[k]));
              headrTemp.disabled=false;//不修改，则主键 在页面配置中 不能点击
              headrTemp.id=headrDataIdx;//在页面配置中正确记录click的值
              headrTemp.DATAURL=this.unionData.data[j].DATAURL;
              headrData.push(headrTemp);
              headrDataIdx++;
              break;
            }
          }
        }
      }
      //获取 对应表的 勾选字段 信息和id
      for (let j = 0; j < this.unionData.data.length; j++) {
        // let checked=[];//记录展示字段在表头列表中的位置
        let headChecked = [];//将 各单表 选中表头记录 单独封装为一个对象
        let HEAD = this.unionData.HEAD.slice(0);//复制 所有选中表头名称列表
        for (let k = 0; k < this.unionData.data[j].headNew.length; k++) {
          if (HEAD.indexOf(this.unionData.data[j].headNew[k].COLUMN_NAME) != -1) {
            headChecked.push(this.unionData.data[j].headNew[k]);
            // checked.push(this.unionData.data[j].headNew[k].id.toString());
            // HEAD.splice(HEAD.indexOf(this.unionData.data[j].headNew[k].COLUMN_NAME),1);
          }
        }
        // for (let k = 0; k < this.unionData.data[j].HEAD.length; k++) {
        //   if (HEAD.indexOf(this.unionData.data[j].HEAD[k].COLUMN_NAME) != -1){
        //     checked.push(this.unionData.data[j].HEAD[k].id.toString());
        //   }
        //   if(checked.indexOf(this.unionData.data[j].HEAD[k].id.toString())!=-1){
        //     headChecked.push(this.unionData.data[j].HEAD[k]);
        //   }
        // }
        this.unionData.data[j].headChecked=headChecked;
        // this.unionData.data[j].checked=checked;
      }
      console.log(headrData);
      this.unionData.headData=headrData;
      // if (where == 'left') {
      //   for (let itemm in arr) {
      //     console.log(arr[itemm])
      //     for (let i = 0; i < this.theHeader.length; i++) {
      //       if (this.theHeader[i].id == arr[itemm]) {
      //         console.log(this.theHeader[i])
      //         delete this.theHeader[i].router
      //         console.log(this.theHeader[i])
      //       }
      //     }
      //   }
      // }
    },
    //构建表头 点击 确定
    confirmHeadChecked(){
      console.log( this.unionData);
      this.dialogCreateHead=false;
    },

    //计算属性——自定义方法
    onCustomHaed(row,type){
      console.log(row, type);
      //逻辑判断:字段与符号只能点击一次，数字除外——字段：h，符号：s，数字：n
      if (type == this.customClickType && type != 'n') {
        return;
      }
      //逻辑判断：点击字段后不能点击数字，点击数字后不能点击字段
      if ((this.customClickType == 'h' && type == 'n') || (this.customClickType == 'n' && type == 'h')) {
        return;
      }

      this.customClickType = type;
      if (("key" in row) && row.key == "()") {
        this.customClickType = "h";
      }

      if(type=='h'){
        this.custom.formula=this.custom.formula+row.data;
        this.custom.formulaStr=this.custom.formulaStr+row.COMMENTS;
        if (!(row.data in this.custom.params)){
          this.custom.keys.push(row.data);
        }
        this.custom.params[row.data]=1;
      }
      if (type=='s'){
        if (row.value=="()"){
          this.custom.formula="("+this.custom.formula+")";
          this.custom.formulaStr="("+this.custom.formulaStr+")";
        }else {
          this.custom.formula=this.custom.formula+row.key;
          this.custom.formulaStr=this.custom.formulaStr+row.value;
        }
      }
      if (type=='n'){
        if (row.value=="C"){
          this.custom.formula=this.custom.formula.substring(0,this.custom.formula.length-1);
          this.custom.formulaStr=this.custom.formulaStr.substring(0,this.custom.formulaStr.length-1);
        }else {
          this.custom.formula=this.custom.formula==undefined ? row.key : this.custom.formula+row.key;
          this.custom.formulaStr=this.custom.formulaStr==undefined ? row.value :  this.custom.formulaStr+row.value;
        }
      }
      console.log(this.custom.formula);
      console.log(this.custom);
    },

    //计算属性——自定义 点击测试
    onCustomTest(){
      console.log(this.custom);
      axios({
        url: process.env.VUE_APP_SERVER + "/dataprovider/systemdata/alg/custom",
        method:"post",
        headers:{
          "Content-Type": "application/json"
        },
        data:{
          customDTO:this.custom
        }
      }).then((res)=>{
        console.log(res);
        if (res.data.data=="NaN"){
          alert("自定义算法有误！请修正")
        }else {
          alert("算法测试通过")
        }
      }).catch((err)=>{
        alert("Error");
        console.log(err);
        return;
      })

    },
    //计算属性——自定义，点击重置
    onCustomReset(){
      this.custom={
        params:{},
        keys:[],
        formula:"",
        formulaStr:"",
      };
      this.customClickType="s";
    },
  },
  watch:{
    //监听 数据关联绑定数据，筛选下拉框数据信息
    unionDataFilterText(val) {
      this.$refs.unionDataTree.filter(val);
      this.isDataUsrTree=true;
    },
    //监听 计算属性对话框标识，用于对话框关闭时初始化参数
    dialogSeriesChecked(){
      console.log("dialogSeriesChecked：",this.dialogSeriesChecked);
      if(!this.dialogSeriesChecked){
        this.checkedSeriesKeys=[];
        this.customClickType="s";
      }
    },
    //监听 表头数据对话框标识，用于对话框关闭时初始化参数
    dialogTableVisible(){
      if (!this.dialogTableVisible){
        this.seriesPrimaryKey= {
          KEY_COLUMN_NAME:[],//主键字段名称
          KEY_COMMENTS:[],//主键字段代码
          DATSRC_ID:"",//数据源ID
          SEQUENCE:[],//序号
        };//主键——表头数据
      }
    },
  }
}
</script>
<style lang="less">
.el-row {
  margin-bottom: 20px;
}

.page-tree {
  position: relative;
  overflow: auto;
  width: 150%;
  height: 600px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
}

.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.remark {
  width: 550px
}
.module-pagetree {
  position: absolute;
  overflow: auto;
  width: 100%;
  height: auto;
  max-height : 500px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
  opacity: 0.8;
}
.module-pagetreeNew {
  position: relative;
  overflow: auto;
  width: 100%;
  height: 500px;
  max-height : 500px;
  border: 1px solid #ddd;
  line-height: normal;
  z-index: 204;
}
.button-icon-operation{
  font-size: 30px;
  padding: 5px 15px;
  margin-left: 0px;
  //border-style: solid;
  //border-width: 1px;
  //width: 30px;
  //height: 25px;
  //text-align: center;
}
</style>